/* eslint-disable */
// Estado de UI compartilhado entre componentes que não têm relação
// direta de pai/filho (ex: sidebar e barra de abas abrindo o mesmo
// command palette de busca, ou o tooltip de horários que precisa
// renderizar por cima das abas/relatório).

export default {
    namespaced: true,

    state: {
        comandoAberto: false,
        tooltipHorario: null
    },

    getters: {
        comandoAberto: (state) => state.comandoAberto,
        tooltipHorario: (state) => state.tooltipHorario
    },

    mutations: {
        SET_COMANDO(state, valor) {
            state.comandoAberto = valor
        },
        SET_TOOLTIP_HORARIO(state, valor) {
            state.tooltipHorario = valor
        }
    },

    actions: {
        abrirComando({ commit }) {
            commit('SET_COMANDO', true)
        },
        fecharComando({ commit }) {
            commit('SET_COMANDO', false)
        },
        mostrarTooltipHorario({ commit }, payload) {
            commit('SET_TOOLTIP_HORARIO', payload)
        },
        ocultarTooltipHorario({ commit }) {
            commit('SET_TOOLTIP_HORARIO', null)
        }
    }
}
